









import { Ingredient } from '@/types/Ingredient.d.ts';
import IngredientVue from '@/components/Ingredient.vue';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  components: {
    IngredientVue,
  },
  props: {
    ingredients: Array as PropType<Ingredient[]>,
  },
});
